import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";
import { useRouteError } from "react-router";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// NotFoundScreen => Rename all instances to use
type NotFoundScreenProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################
const _NotFoundScreen = (props: NotFoundScreenProps) => {
  const err = useRouteError() as any;

  const info = {
    status: err.status || "inesperado",
    reason: err.data || "Algo salió mal...",
    message: err.statusText || err.message || "Vuelva a intentarlo más tarde.",
  };

  // ------------------------------------------------------------------------------------ RETURN
  return (
    <div className={props.className + " screen"}>
      <Helmet>
        <title>{"Error " + info.status + " | RSA"}</title>
      </Helmet>

      <h1>{"Error " + info.status}</h1>
      <h3>{info.reason}</h3>
      <p>{info.message.replace(/ *;; */gim, "\n")}</p>

      <Link to={"/"} replace>
        Regresar
      </Link>
    </div>
  );
};

// ################################ STYLES ################################
const NotFoundScreen = styled(_NotFoundScreen).attrs(
  (props: NotFoundScreenProps): NotFoundScreenProps => {
    return { ...props };
  }
)`
  ${(props) => css`
    text-align: center;
    padding: 3rem 0;

    p {
      width: 50%;
      margin: 0 auto;
      font-family: var(--font-cabin);
      white-space: pre-line;
    }

    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default NotFoundScreen;
